import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Button, Glyphicon } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import * as Help from 'modules/app/Help';
import SetupTabView from './SetupTabView';
import SetupListView from './SetupListView';
import * as FormManager from 'fw/forms/form/FormManager';
import * as App from 'modules/app/App';

class SetupPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            prevSearchData: null,
            addNewTitle: this.props.addNewTitle,
            warnOnBack: true
        }
    }

    setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

    // Handlers
    handleSearch = (prevSearchData) => {
        this.setState({
            prevSearchData
        });
    }

    handleReset = (prevSearchData) => {
        this.setState({
            prevSearchData
        });
    }

    handleAdd = () => {
        this.props.history.push(`${this.props.match.path}/new`);
    }

    handleSave = () => {
        if (this.props.backToSearchOnSave)
            this.props.history.push(`${this.props.match.path}`);

        this.props.onSave && this.props.onSave();
    }

    handleDelete = () => {
        this.props.history.push(`${this.props.match.path}`);
    }

    handleRestore = () => {
        const me = this;
        let restorePath = `${me.props.match.url}`;

        if (App.context().lastSetupTabIsSingle != null && App.context().lastSetupTabIsSingle) {
            restorePath = this.props.singleResultCancelUrl;
        }

        if (!this.state.warnOnBack) {
            this.setState({ warnOnBack: true });
            me.props.history.push(restorePath);
        }

        FormManager.checkUnsavedChanges(function () {
            if (me.props.customOnBack) {
                me.props.customOnBack();
                App.updateLastSetupTabIsSingle(false);
                return;
            }
            me.props.history.push(restorePath);
            App.updateLastSetupTabIsSingle(false);
        });
    }

    handleSelect = (id) => {
        this.props.history.push(`${this.props.match.url}/${id}`);
    }

    setWarnOnBack = (warn) => {
        this.setState({ warnOnBack: warn });
    }

    // React
    componentDidMount() {
        this.setHelp();
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title={this.props.title} description={this.props.description}>
                    {(this.props.location.pathname === this.props.match.url) && this.props.addPrivilege && this.props.showAddNew &&
                        <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0 }} onClick={this.handleAdd}>{this.state.addNewTitle}</Button>
                    }
                    {
                        (this.props.location.pathname !== this.props.match.url) &&
                        !App.context().lastSetupTabIsSingle &&
                        <Button id="btnBack" className="pull-right" onClick={this.handleRestore} style={{ marginRight: 0 }} >
                            <Glyphicon glyph="arrow-left" style={{ marginRight: 10 }} />
                            {this.props.backToSearchMsg != null && <React.Fragment>{this.props.backToSearchMsg}</React.Fragment>}
                            {this.props.backToSearchMsg == null && <React.Fragment>Back to search results</React.Fragment>}
                        </Button>
                    }
                </ContentHeader>
                <ContentBody>
                    <Switch>
                        <Route exact path={`${this.props.match.path}/`} render={(props) =>
                            <SetupListView
                                {...props}
                                prevSearchData={this.state.prevSearchData}
                                setupProps={this.props}
                                enableExport={this.props.enableExport}
                                customAction={this.props.customAction}
                                customActionStyle={this.props.customActionStyle}
                                enableSearch={this.props.enableSearch}
                                triggerInitialSearch={this.props.triggerInitialSearch}
                                disableSelect={this.props.disableSelect}
                                onSelect={this.handleSelect}
                                onReset={this.handleReset}
                                onSearch={this.handleSearch} />
                        } />
                        <Route path={`${this.props.match.path}/new`} component={(props) =>
                            <SetupTabView
                                {...props}
                                adding={true}
                                setupProps={this.props}
                                onSave={this.handleSave}
                                onBack={this.handleRestore} />
                        } />
                        <Route path={`${this.props.match.path}/:id/:tabKey?/:reviewMode?`} component={(props) =>
                            <SetupTabView
                                {...props}
                                setupProps={this.props}
                                onSave={this.handleSave}
                                onDelete={this.handleDelete}
                                onBack={this.handleRestore}
                                onSetWarnOnBack={this.setWarnOnBack} />
                        } />
                    </Switch>
                </ContentBody>
            </React.Fragment>
        );
    }
}

SetupPage.defaultProps = {
    addNewTitle: "Create",
    showAddNew: true,
    showTitle: true,
    showButtons: {
        cancel: true,
        save: true,
    },
    backToSearchOnSave: false,
    enableRowSelection: false,
    customAction: null,
    maxRowSelection: 0,
    maxRowSelectionReachedMessage: "Maximun number of selections allowed reached.",
    rowSelectionTooltip: null
}

export default withRouter(SetupPage);


// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupPage.js